<template>
  <div class="row dvContent">
    <BodyLoader :loading="firstLoad"></BodyLoader>

    <div class="dvModals">
      <div id="modal-assign-team-manager" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Assign Team Manager
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Member</label>
                <select class="browser-default defaultModal-input" v-model="assignAsTeamManager">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(member, index) in getTeamUsers(selectedTeamId)" :key="index" :value="member.id">{{ member.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!assignManager"
            @click="assignTeamManager()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Assign
          </a>

          <a
            v-if="assignManager"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Assigning...
          </a>

          <a
            @click="closeModal('modal-assign-team-manager')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-move-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Move to Channel
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Channel</label>
                <select class="browser-default defaultModal-input" v-model="moveToChannel">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(channel, index) in defaultChannels" :key="index" :value="channel.id">{{ channel.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!movingChannel"
            @click="moveChannel()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Move
          </a>

          <a
            v-if="movingChannel"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Moving...
          </a>

          <a
            @click="closeModal('modal-move-team')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-add-member" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Add Member
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="memberData.email" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required (Please enter a valid ALI email address)
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!savingMember"
            @click="addMember()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="savingMember"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            @click="closeModal('modal-add-member')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-add-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            {{ teamData.id == '' ? 'Add' : 'Edit' }} Team
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll"  href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Primary Name</label>
                <input class="browser-default defaultModal-input" type="text"  v-model="teamData.primaryName"/>
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Secondary Name</label>
                <input class="browser-default defaultModal-input" type="text"  v-model="teamData.secondaryName"/>
                <div class="defaultModal-helper-text">
                  Optional (e.g. Team Hustle)
                </div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Channel</label>
                <input class="browser-default defaultModal-input" type="text" v-model="teamData.channel" readonly/>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Manager</label>
                <select class="browser-default defaultModal-input" v-model="teamData.manager">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(user, index) in getTeamUsers(teamData.id)" :key="index" :value="user.id">{{ user.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Monthly Target Group Referral</label>
                <input v-model="teamData.team_target_referrals" class="browser-default defaultModal-input" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Default Country</label>
                <select class="browser-default defaultModal-input" v-model="teamData.country">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(country, index) in defaultCountries" :key="index" :value="country.code">{{ country.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">

          <a
            v-if="!addingTeam"
            @click="saveTeam()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>{{ teamData.id == '' ? 'Add' : 'Save' }}
          </a>

          <a
            v-if="addingTeam"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            {{ teamData.id == '' ? 'Adding' : 'Saving' }}...
          </a>

          <a
            :disabled="addingTeam"
            @click="closeModal('modal-add-team')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

    </div>


    <div class="col dvResultsContentMain">
      <SearchResultNav :q="q"></SearchResultNav>

      <div class="row dvResultsContent forAdmin">
        <div class="dvResultsBar">
          Found <strong>{{ pager.totalRecords }}</strong> result {{ pager.totalRecords > 1 ? 's' : '' }} for <strong>"{{q}}"</strong> in Teams
        </div><!-- dvResultsBar -->
        <div class="col s12 dvContentMain">

          <div class="dvCards-container">

            <ContentLoader :loading="loading" :firstLoad="firstLoad"></ContentLoader>

            <div
              v-show="pager.totalRecords == 0 && !loading"
              class="dvBlankSection">
              <div class="dvBlankSectionBox flexCenterAll">
                <div class="dvBlankSection-content">
                  <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
                  <div class="dvBlankSection-text-primary center-align">
                    There are no teams to display
                  </div>
                  <div class="dvBlankSection-text-secondary center-align">
                    Try using the search box above to find what you are looking for.
                  </div>
                </div>
              </div>
            </div>


            <div class="row">

              <div
                v-for="(team, index) in teams" :key="index"
                class="col s12 m12 l6">
                <div class="dvCardClient">
                  <div class="dvCardClient-header">
                    <div class="dvCardClient-header-name">
                      <div class="dvCardClient-header-name-info">
                        {{ team.name }} {{ team.team_name.length > 0 ? '('+team.team_name+')' : '' }}
                      </div> <!-- dvCardClient-header-name-info -->
                    </div> <!-- dvCardClient-header-name -->
                    <div class="dvCardClient-header-menu">
                      <a
                        :name="'listview-menu-'+index"
                        :ref="'tippy_menu'+index"
                        class="waves-effect waves-light dvCardClient-header-link flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>
                    </div> <!-- dvCardClient-header-menu -->
                  </div> <!-- dvCardClient-header -->
                  <tippy
                   v-bind:to="'listview-menu-'+index"
                   placement="left"
                   offset="[10, 2]"
                   interactive
                   arrow
                   trigger="click">
                   <div class="morePopMenuBox-content ">

                     <!-- <router-link
                       class="morePopMenuBox-content-item"
                       :to="{ name:'admin_channel', params: { id: team.id } }">
                       <span class="icon-editor_view"></span>View
                     </router-link> -->

                     <router-link
                       class="morePopMenuBox-content-item"
                       :to="{ name:'admin_teams', params: { id: team.id } }">
                       <span class="icon-editor_view"></span>View Team
                     </router-link>

                     <a
                      @click="showEditTeamModal(team)"
                      href="javascript:void(0)" class="morePopMenuBox-content-item">
                       <span class="icon-action_edit"></span>Edit Team
                     </a>

                     <a
                      @click="showMoveToChannelModal(team)"
                      href="javascript:void(0)" class="morePopMenuBox-content-item">
                       <span class="icon-nav_arrow_next"></span>Move Team
                     </a>

                     <a
                      @click="showAddMember(team.id)"
                      href="javascript:void(0)" class="morePopMenuBox-content-item">
                       <span class="icon-fs_user"></span>Add Member
                     </a>

                     <a
                      v-if="team.manager_id && team.manager_id.length != 0 && team.manager_id != 0"
                      @click="confirm({
                        id: team.id,
                        type: 'remove-team-manager',
                        teamName: team.name
                      })"
                      href="javascript:void(0)" class="morePopMenuBox-content-item">
                       <span class="icon-action_close"></span>Remove Team Manager
                     </a>
        <!-- v-if="team.members.length > 0 && team.manager_id && (team.manager_id.length == 0 || team.manager_id == 0)" -->
                     <a
                      v-if="team.members.length > 0 && ( !team.manager_id || team.manager_id == 0)"
                      @click="showAssignTeamManagerModal(team.id)"
                      href="javascript:void(0)" class="morePopMenuBox-content-item">
                       <span class="icon-action_star"></span>Assign Team Manager
                     </a>

                     <a
                      @click="confirm({
                        id: team.id,
                        type: 'archive',
                        teamName: team.name
                      })"
                      href="javascript:void(0)" class="morePopMenuBox-content-item">
                       <span class="icon-action_archive"></span>Archive
                     </a>


                     <!-- <a
                      @click="confirm({
                        id: channel.id,
                        type: 'archive',
                        channelName: channel.name
                      })"
                      href="javascript:void(0)" class="morePopMenuBox-content-item">
                       <span class="icon-action_archive"></span>Archive
                     </a> -->

                   </div>
                 </tippy>
                  <div class="dvCardClient-content">
                    <div class="dvCardClient-content-items forList">
                      <div class="row">

                        <div class="col s6" v-for="(chunk, idx) in memberChunks(team.members)" :key="idx">
                          <router-link
                            v-for="(member, mindex) in chunk" :key="mindex"
                            class="dvCardClient-list-item" :class="{ isPrimary: (member.role == $getConstRole('ROLE_MANAGER')) }"
                            :to="{ name:'admin_team_member', params: { id: member.id, team_id: team.id, status: 'valid' } }">
                            <span v-if="member.role == $getConstRole('ROLE_MANAGER')" class="icon-action_star"></span>
                            <span v-if="member.role != $getConstRole('ROLE_MANAGER')" class="icon-fs_user"></span>
                            {{ member.name }}
                          </router-link>
                        </div>

                      </div>
                    </div> <!-- dvCardClient-content-items -->

                    <div class="row dvCardClient-content-action">




                      <div class="col s6">
                        <router-link
                          tag="div"
                          class="waves-effect waves-dark btn-RoundCorners"
                          :to="{ name:'admin_teams', params: { id: team.id } }">
                          <span class="icon-fs_search"></span><div class="label">View Team</div>
                        </router-link>
                      </div> <!-- col -->
                      <div class="col s6">
                        <div @click="showAddMember(team.id)" href="javascript:void(0)" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-action_add"></span><div class="label">Add Member</div></div>
                      </div> <!-- col -->
                    </div> <!-- dvCardClient-content-action -->
                  </div> <!-- dvCardClient-content -->
                </div> <!-- dvCardClient -->
              </div> <!-- col -->

            </div> <!-- row -->

          </div>
        </div>
      </div> <!-- dvResultsContent forAdmin-->

    </div> <!-- dvResultsContentMain -->

    <div class="col s12 dvContentTools">
      <div class="dvContentTools-fx"></div>
      <div class="dvContentTools-content">
        <a
          :class="{ disabled: (pager.currentPage < 2 || loading) ? true : false }"
          @click="previousPage()"
          href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
          <span class="icon-nav_chevron_left"></span>Previous
        </a>
<!--  -->
        <div class="dvContentTools-pagination">
          <form id="frmChangePassword" @submit.prevent="setPage">
            <input
              type="text" class="browser-default" v-model="pager.currentPage" />
          </form>
          <div class="dvContentTools-pagination-label">of {{ pager.totalPages }}</div>
          <!-- <div class="dvContentTools-pagination-label">{{ pager.dataStart }} of {{ pager.totalRecords }}</div> -->
        </div>

        <a
          :class="{ disabled: !pager.hasNext || loading }"
          @click="nextPage()"
          href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
          Next<span class="icon-nav_chevron_right"></span>
        </a>
      </div>
      <div class="dvContentTools-page">
        <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
        <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
        <ToTop></ToTop>
      </div>
    </div>

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>

  </div> <!-- dvContent -->
</template>

<script>
  import BodyLoader from '@/components/BodyLoader.vue'
  import SearchResultNav from './SearchResultNav.vue'
  import _ from 'lodash'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import ContentLoader from '@/components/ContentLoader.vue'
  import M from 'materialize-css'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'search-result-teams',
    data: () => ({
      q: '',
      teams: [],
      filter_by: '',
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      pager: {
        currentPage: 1,
        perPage: 10,
        hasNext: 0,
        totalRecords: 0,
        totalPages: 0,
        dataStart: 0
      },
      loading: false,
      firstLoad: true,
      noRecordFound: false,
      defaultUsers: [],
      defaultChannels: [],
      defaultCountries: [],
      archiving: false,
      movingChannel: false,
      moveToChannel: '',
      teamTomove: '',
      assignManager: false,
      assignAsTeamManager: '',
      selectedTeamId: '',
      addingTeam: false,
      teamData: {
        id: '',
        primaryName: '',
        secondaryName: '',
        channel: '',
        manager: '',
        team_target_referrals: '',
        country: ''
      },
      savingMember: false,
      memberData: {
        email: '',
        team_id: '',
        channel_id: '',
      },
    }),
    watch: {
      $route (to, from){
        let q = to.query.q
        this.q = q
        this.pager.currentPage = 1
        this.search()
      }
    },
    computed: {
      referralChunks(){
        return _.chunk(Object.values(this.referrals), 2);
      }
    },
    methods: {
      search (){
        if(this.loading){
          return false;
        }

        if(this.q == ''){
          this.showMessage('The keyword field is required.', 'sb-failed')
          return false
        }

        let self = this
        this.loading = true
        this.noRecordFound = false
        this.selected = [];
        this.referrals = [];
        let url = 'api/search/teams?q='+this.q+'&page='+this.pager.currentPage+'&per_page='+this.pager.perPage

        this.$http.plain.get(url)
          .then(response => {

            // let referrals = response.data.referrals
            // for (let i = 0; i < referrals.length; i++){
            //   referrals[i].selected = false
            //   this.referrals.push(referrals[i])
            // }


            this.teams = response.data.teams;

            if(this.teams.length == 0){
              this.noRecordFound = true
            }

            this.pager.hasNext = response.data.pager.has_next_page
            this.pager.totalRecords = response.data.pager.total_records
            this.pager.dataStart = response.data.pager.data_start
            this.pager.totalPages = response.data.pager.total_pages
            // document.getElementById("toFocus").focus();
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.firstLoad = false
            self.$emit('firstLoadDone')
          })
        },
        setPage (){
          // let page = parseInt(this.pager.currentPage)
          // console.log(page)
          // || !Number.isInteger(page)
          if(this.pager.currentPage > this.pager.totalPages || this.pager.currentPage < 1){
            this.pager.currentPage = 1
          }

          this.search();
        },
        previousPage (){
          window.scroll(0, 0)
          this.pager.currentPage--;
          this.search();
        },
        nextPage (){
          window.scroll(0, 0)
          this.pager.currentPage++;
          this.search();
        },
        showAssignTeamManagerModal (team_id){
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          this.selectedTeamId = team_id
          this.showModal('modal-assign-team-manager')
        },
        getTeamUsers (team_id){
          let teamUsers = this.defaultUsers.filter(user => {
            return user.team_id == team_id
          })
          return teamUsers
        },
        assignTeamManager () {
          if(this.assignAsTeamManager == ''){
            this.showMessage('Member is required.', 'sb-failed')
            return false
          }

          if(this.assignManager){
            return false;
          }
          this.assignManager = true
          let self = this

          this.$http.secured.post('/api/admin/teams/assign-as-manager/'+ this.selectedTeamId+'/'+this.assignAsTeamManager)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
              this.closeModal('modal-assign-team-manager')
              this.selectedTeamId = ''
              this.assignAsTeamManager = ''
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
            .then(function () {
              self.assignManager = false
            })
        },
        removeTeamManager (team_id){
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          this.$http.secured.post('/api/admin/teams/remove-manager/'+ team_id)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
              this.closeModal('modal-move-team')
              this.teamTomove = ''
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
        },
        moveChannel () {
          if(this.movingChannel){
            return false;
          }
          this.movingChannel = true
          let self = this

          this.$http.secured.post('/api/admin/teams/move-to-channel/'+ this.teamTomove + '/' + this.moveToChannel)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
              this.closeModal('modal-move-team')
              this.teamTomove = ''
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
            .then(function () {
              self.movingChannel = false
            })
        },
        saveTeam (){
          if(this.teamData.id == ''){
            this.addTeam()
          }else{
            this.updateTeam()
          }
        },
        updateTeam (){
          if(this.teamData.primaryName == ''){
            this.showMessage('The primary name field is required.', 'sb-failed')
            return false
          }

          if(this.teamData.team_target_referrals == ''){
            this.showMessage('The monthly target group referral field is required.', 'sb-failed')
            return false
          }

          if(this.addingTeam){
            return false
          }

          let self = this
          self.addingTeam = true

          let url = '/api/admin/teams/'+this.teamData.id

          let data = {
            id: this.teamData.id,
            name: this.teamData.primaryName,
            team_name: this.teamData.secondaryName,
            channel_id: this.id,
            manager_id: this.teamData.manager,
            team_target_referrals: this.teamData.team_target_referrals,
            country: this.teamData.country
          }

          this.$http.secured.put(url, data)
            .then(response => {
              this.showMessage('Team has been successfully updated', 'sb-success')
              this.closeModal('modal-add-team')
              this.teamData = {
                id: '',
                primaryName: '',
                secondaryName: '',
                channel: '',
                manager: '',
                team_target_referrals: '',
                country: ''
              }
              this.search()
            })
            .catch(error => {
              if (error.response) {
                let errors = error.response.data.messages
                let msg = []
                Object.keys(errors).forEach(key => {
                  msg.push(errors[key])
                })
                this.showMessage(msg.join(','), 'sb-failed')

              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            })
            .then(function () {
              self.addingTeam = false
            })
        },
        addTeam (){
          if(this.teamData.primaryName == ''){
            this.showMessage('The primary name field is required.', 'sb-failed')
            return false
          }

          if(this.teamData.team_target_referrals == ''){
            this.showMessage('The monthly target group referral field is required.', 'sb-failed')
            return false
          }

          if(this.addingTeam){
            return false
          }

          let self = this
          self.addingTeam = true

          let url = '/api/admin/teams'

          let data = {
            name: this.teamData.primaryName,
            team_name: this.teamData.secondaryName,
            channel_id: this.id,
            manager_id: this.teamData.manager,
            team_target_referrals: this.teamData.team_target_referrals,
            country: this.teamData.country
          }

          this.$http.secured.post(url, data)
            .then(response => {
              this.showMessage('Team has been successfully created', 'sb-success')
              this.closeModal('modal-add-team')
              this.teamData = {
                id: '',
                primaryName: '',
                secondaryName: '',
                channel: '',
                manager: '',
                team_target_referrals: '',
                country: ''
              }
              this.search()
            })
            .catch(error => {
              if (error.response) {
                let errors = error.response.data.messages
                let msg = []
                Object.keys(errors).forEach(key => {
                  msg.push(errors[key])
                })
                this.showMessage(msg.join(','), 'sb-failed')

              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            })
            .then(function () {
              self.addingTeam = false
            })
        },
        showMoveToChannelModal (team){
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          this.moveToChannel = team.channel_id
          this.teamTomove = team.id
          this.showModal('modal-move-team')
        },
        showEditTeamModal (team){
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          this.teamData.id = team.id
          this.teamData.primaryName = team.name
          this.teamData.secondaryName = team.team_name
          this.teamData.team_target_referrals = team.team_target_referrals
          this.teamData.country = team.country

          if(team.manager_id != 0 && team.manager_id){
            this.teamData.manager = team.manager_id
          }


          this.teamData.channel = team.channel
          this.showModal('modal-add-team')
        },
        showAddTeamModal (){
          this.teamData = {
            id: '',
            primaryName: '',
            secondaryName: '',
            channel: '',
            manager: '',
            country: '',
            team_target_referrals: ''
          }
          this.teamData.channel = this.channel.name
          this.showModal('modal-add-team')
        },
        showMessage(msg, color){
          this.snackbarDetails = {
            color: color,
            msg: msg,
            show: true
          }
        },
        showAddMember (selectedTeamId) {
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          this.selectedTeamId = selectedTeamId
          this.showModal('modal-add-member')
        },
        addMember (){

          if(this.memberData.email == ''){
            this.showMessage('The email field is required.', 'sb-failed')
            return false
          }

          if(this.savingMember){
            return false
          }

          let self = this
          self.savingMember = true

          this.memberData.team_id = this.selectedTeamId
          this.memberData.channel_id = this.id

          this.$http.secured.post('api/admin/members', this.memberData)
            .then(response => {
              this.closeModal('modal-add-member')
              this.showMessage('Member has been successfully registered. Email sent to ' + response.data.email, 'sb-success')
              this.memberData.email = ''
              this.memberData = {
                email: '',
                team_id: '',
                channel_id: '',
              }
              this.search()
            })
            .catch(error => {
              if (error.response) {
                let errors = error.response.data.messages
                let msg = []
                Object.keys(errors).forEach(key => {
                  msg.push(errors[key])
                })
                this.showMessage(msg.join(','), 'sb-failed')

              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            })
            .then(function () {
              self.savingMember = false
            })
        },
        confirm (action){
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          if(action.type == 'remove-member'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to remove this?',
              body: 'You can\'t undo this action.',
              icon: 'icon-action_delete',
              positionBtn: 'Remove',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type == 'archive'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to archive '+action.teamName+'?',
              body: 'You can\'t undo this action.',
              icon: 'icon-action_archive',
              positionBtn: 'Archive',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type == 'remove-team-manager'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to remove the team manager?',
              body: 'You can\'t undo this action.',
              icon: 'icon-action_delete',
              positionBtn: 'Remove',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }

        },
        doConfirm (){
          this.dialog.show = false

          if(this.dialog.actionType == 'remove-member'){
            this.processRemoveMember(this.dialog.id)
          }else if(this.dialog.actionType == 'archive'){
            this.processArchive(this.dialog.id)
          }else if(this.dialog.actionType == 'remove-team-manager'){
            this.removeTeamManager(this.dialog.id)
          }
        },
        processArchive (id) {
          if(this.archiving){
            return false;
          }
          this.archiving = true
          let self = this

          this.$http.secured.post('/api/admin/teams/archive/'+ id)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
            .then(function () {
              self.archiving = false
            })
        },
        processRemoveMember (id){
          this.$http.secured.delete('api/members/'+ id)
            .then(response => {
              this.showMessage('Member has been successfully deleted', 'sb-success')
              this.getMembers()
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
        },
        showModal (str){
          const elem = document.getElementById(str);
          const instance = M.Modal.init(elem, {dismissible: false});
          instance.open();
        },
        closeModal (str){
          const elem = document.getElementById(str);
          const instance = M.Modal.init(elem, {dismissible: false});
          instance.close();


          this.memberData.email = ''
          this.teamTomove = ''
        },
        memberChunks (members){
          let len = members.length
          let div = members.length / 2
          if(len % 2){
            div = div + 1
          }

          return _.chunk(Object.values(members), div);
        },
        getDefaultData () {
          this.$http.plain.get('api/default-data')
            .then(response => {
              this.defaultUsers = response.data.users
              this.defaultChannels = response.data.channels
              this.defaultCountries = response.data.countries
            })
            .catch(error => {
              console.log(error);
            })
        }

    },
    mounted() {
      this.q = this.$route.query.q
      this.search()
      this.getDefaultData()
    },
    components: {
      SnackBar,
      ConfirmationDialog,
      ContentLoader,
      BodyLoader,
      SearchResultNav,
      ToTop
    }

  }
</script>
